import React from "react";
import { Row, Col } from "react-bootstrap";
import { CommonInput, CommonSelect } from "../../Input";

const Step3PaymentInfo = ({ formData, setFormData }) => {
  const labelClass = "fw-bold text-black fs-13 mb-2";
  const EXCHANGE_RATE = 36.45;

  const handleTransferAmountChange = (e) => {
    const val = e.target.value;
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      const receiveVal = val ? (parseFloat(val) * EXCHANGE_RATE).toFixed(2) : "";
      setFormData({
        ...formData,
        transferAmount: val,
        receiveAmount: receiveVal,
      });
    }
  };

  const handleReceiveAmountChange = (e) => {
    const val = e.target.value;
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      const transferVal = val ? (parseFloat(val) / EXCHANGE_RATE).toFixed(2) : "";
      setFormData({
        ...formData,
        receiveAmount: val,
        transferAmount: transferVal,
      });
    }
  };

  return (
    <div className="mt-4">
      {/* Row 1: Currency, Purpose, Source */}
      <Row className="mb-4">
        <Col md={3}>
          <CommonSelect
            label="Send currency"
            labelClass={labelClass}
            placeholder="Select send currency"
            value={{
              value: formData?.sendCurrency || "SGD",
              label:
                formData?.sendCurrency === "USD"
                  ? "US Dollar"
                  : "Singapore Dollar",
            }}
            onChange={(opt) =>
              setFormData({ ...formData, sendCurrency: opt.value })
            }
            options={[
              { value: "SGD", label: "Singapore Dollar" },
              { value: "USD", label: "US Dollar" },
            ]}
          />
        </Col>
        <Col md={3}>
          <CommonSelect
            label="Receive currency"
            labelClass={labelClass}
            placeholder="Select receive currency"
            value={{ value: "PHP", label: "Philippine Peso" }}
            options={[{ value: "PHP", label: "Philippine Peso" }]}
            isDisabled={true}
          />
        </Col>
        <Col md={3}>
          <CommonSelect
            label="Purpose of transfer"
            labelClass={labelClass}
            placeholder="Select purpose of transfer"
            value={formData?.purpose ? { value: formData.purpose, label: formData.purpose.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') } : null}
            onChange={(opt) => setFormData({ ...formData, purpose: opt.value })}
            options={[
              { value: "savings", label: "Savings" },
              {
                value: "living_family_expenses",
                label: "Living & family expenses",
              },
              {
                value: "supplier_vendor_agent_payment",
                label: "Supplier/vendor/agent payment",
              },
              { value: "payroll", label: "Payroll" },
              { value: "business_expenses", label: "Business expenses" },
              { value: "property_payment", label: "Property payment" },
              { value: "loan_repayment", label: "Loan repayment" },
              { value: "bills_payment", label: "Bills payment" },
              { value: "investment", label: "Investment" },
              { value: "travel", label: "Travel" },
              { value: "donation", label: "Donation" },
              { value: "hospital_fees", label: "Hospital fees" },
              { value: "school_exam_fees", label: "School/exam fees" },
            ]}
          />
        </Col>
        <Col md={3}>
          <CommonSelect
            label="Source of funds"
            labelClass={labelClass}
            placeholder="Select source of funds"
            value={formData?.source ? { value: formData.source, label: formData.source.charAt(0).toUpperCase() + formData.source.slice(1).replace(/_/g, ' ') } : null}
            onChange={(opt) => setFormData({ ...formData, source: opt.value })}
            options={[
              { value: "salary", label: "Salary" },
              { value: "savings", label: "Savings" },
              { value: "business", label: "Business" },
              { value: "sale_of_property", label: "Sale of property" },
              { value: "dividends", label: "Dividends" },
              { value: "lottery", label: "Lottery" },
              { value: "loan", label: "Loan" },
            ]}
          />
        </Col>
      </Row>

      {/* Row 2: Amounts, Fee, Remark */}
      <Row className="mb-4">
        <Col md={3}>
          <CommonInput
            label="Transfer amount"
            labelClass={labelClass}
            placeholder="Enter transfer amount"
            prefix={formData?.sendCurrency || "SGD"}
            value={formData?.transferAmount || ""}
            onChange={handleTransferAmountChange}
          />
          <div className="mt-2">
            <h4 className="fs-14 text-secondary">
              1 {formData?.sendCurrency || "SGD"} = 36.45 PHP
            </h4>
          </div>
        </Col>
        <Col md={3}>
          <CommonInput
            label="Receive amount"
            labelClass={labelClass}
            placeholder="Enter receive amount"
            prefix="PHP"
            value={formData?.receiveAmount || ""}
            onChange={handleReceiveAmountChange}
          />
        </Col>
        <Col md={3}>
          <CommonInput
            label="Fee"
            labelClass={labelClass}
            placeholder="0"
            value={formData?.fee || "0"}
            onChange={(e) => setFormData({ ...formData, fee: e.target.value })}
          />
        </Col>
        <Col md={3}>
          <CommonInput
            label="Remark (Optional)"
            labelClass={labelClass}
            placeholder="Enter remark"
            value={formData?.remark || ""}
            onChange={(e) => setFormData({ ...formData, remark: e.target.value })}
          />
        </Col>
      </Row>

      <style>{`
        .form-control:focus {
           box-shadow: none;
           border-color: var(--primary);
        }
      `}</style>
    </div>
  );
};

export default Step3PaymentInfo;
